import { render, staticRenderFns } from "./BoardAdmin.vue?vue&type=template&id=223f2ad5&"
import script from "./BoardAdmin.vue?vue&type=script&lang=ts&"
export * from "./BoardAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports